// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var PlanVariantEditController = function($rootScope,
    $scope,
    $location,
    $routeParams,
    $q,
    $modal,
    ProductInfo,
    ProductPrices,
    PriceListItems,
    PlanVariant,
    PlanVariantByPlan, gettext) {

    $scope.NextStepsAfterFirstPeriodArray = [
        { "value": "RenewAutomatically", "text": gettext("Renew Automatically") },
        { "value": "EndAfterFirstPeriod", "text": gettext("End") },
        { "value": "ChangeAfterFirstPeriod", "text": gettext("Change Plan Variant") }
    ];

    $scope.clonedPlanVariantPriceListItems = [];
    $scope.oldCollection = [];

    if ($routeParams.planVariantId)
        $scope.productInfo = ProductInfo.get(function() {
            $scope.planVariant = PlanVariant.get({ planVariantId: $routeParams.planVariantId },
                function() {
                    $scope.plan = $scope.productInfo.PlanById($scope.planVariant.PlanId);
                    $scope.planGroup = $scope.productInfo.PlanGroupById($scope.plan.PlanGroupId);
                    $scope.components = $scope.productInfo.ComponentsByPlanGroupId($scope.plan.PlanGroupId);
                    $scope.updateFilter();
                });
        });
    else {
        $scope.productInfo = ProductInfo.get(function() {
            $scope.plan = $scope.productInfo.PlanById($routeParams.planId);
            $scope.planGroup = $scope.productInfo.PlanGroupById($scope.plan.PlanGroupId);
            $scope.components = $scope.productInfo.ComponentsByPlanGroupId($scope.plan.PlanGroupId);

            $scope.planVariant = new PlanVariantByPlan();
            $scope.planVariant.PlanId = $routeParams.planId;
            $scope.planVariant.RecurringFee = undefined;
            $scope.planVariant.SetupFee = undefined;
            $scope.planVariant.FeePeriod = {"Quantity": 1, "Unit": "Month"};
            $scope.planVariant.BillingPeriod = {"Quantity": 1, "Unit": "Month"};
            $scope.planVariant.ContractPeriod = {"Quantity": 1, "Unit": "Month"};
            $scope.planVariant.LaterContractPeriod = {"Quantity": 1, "Unit": "Month"};
            $scope.planVariant.CancellationPeriod = {"Quantity": 1, "Unit": "Month"};
            $scope.planVariant.LaterCancellationPeriod = {"Quantity": 1, "Unit": "Month"};
            $scope.planVariant.AfterFirstContractPeriodNextStep = $scope.NextStepsAfterFirstPeriodArray[0].value;
            $scope.updateFilter();
        });
    }
    if (!$scope.search)
        $scope.search = "";

    $scope.overrideStep = function (step) {
        const oldStep = step;
        return function () {
            if ($scope.unsavedItems) {
                let modalInstance = $modal.open({
                    templateUrl: 'partials/error-dialog.html',
                    controller: ['$scope', '$uibModal', 'error', function ($scope, $modalInstance, error) {
                        $scope.error = error;

                        $scope.close = function () {
                            modalInstance.close();
                        };
                    }],
                    windowClass: "fade in",
                    resolve: {
                        error: function () {
                            return "You have made changes on this page which are not saved yet. Please save current page or cancel changes before changing page";
                        }
                    }
                });
                return;
            }
            oldStep();
        }
    }

    $scope.updateFilter = function () {
        ProductPrices.query({
            productId: $routeParams.planVariantId,
            planGroupId: $scope.planGroup.Id,
            search: $scope.search
        }).$promise.then(
            function (response) {
                if (response.length === 1 && ($scope.search === "" || !$scope.search)) {
                    if (!response[0].OneOffPrice && !response[0].RecurringPrice)
                        $scope.DefinePrice(response[0]);
                    $scope.onePriceListItem = true;
                } else {
                    $scope.onePriceListItem = false;
                }
                $scope.fullPlanVariantPriceListItems = response.map(obj => ({ ...obj, Id: obj.PriceListId }));

                $scope.planVariantPriceListItems = $scope.paginator(function (options, callback) {
                    let list = null;
                    let index = 0;
                    if (options.from !== "") {
                        index = $scope.fullPlanVariantPriceListItems.findIndex(x => x.Id === options.from)
                    }
                    list = $scope.fullPlanVariantPriceListItems.slice(index, index + options.take);

                    let query = function (success) {
                        let deferred = $q.defer();
                        let promise = deferred.promise;
                        promise.then(success);
                        deferred.resolve(list);
                        return promise.$$state.value;
                    };
                    return query(function () {
                        if ($scope.unsavedItems > 0) {
                            return;
                        }
                        callback();
                        setupDirty();
                        SetIsOverriddenFlagAndCloneItems();
                    });
                }, {
                    planVariantId: $routeParams.planVariantId,
                    planGroupId: $scope.planGroup.Id,
                    search: $scope.search
                }, 20);

                $scope.planVariantPriceListItems.first = $scope.overrideStep($scope.planVariantPriceListItems.first);
                $scope.planVariantPriceListItems.next = $scope.overrideStep($scope.planVariantPriceListItems.next);
                $scope.planVariantPriceListItems.prev = $scope.overrideStep($scope.planVariantPriceListItems.prev);
            }
        );
    };

    function SetIsOverriddenFlagAndCloneItems() {
        $scope.planVariantPriceListItems.items.forEach(function (item) {
            if (!item.ParentPriceListId) {
                item.IsOverridden = false;
                return;
            }

            const parentItem = GetPlanVariantPriceListItem(item);

            // If item in Child PL doesn't have defined 'OneOffPrice' and 'RecurringPrice' and linked Parent PL has an item with defined 'OneOffPrice' and 'RecurringPrice', child item 'inherits' values from the parent item.
            if (!item.OneOffPrice && !item.RecurringPrice && parentItem?.OneOffPrice && parentItem?.RecurringPrice) {
                item.OneOffPrice = {...parentItem.OneOffPrice};
                item.RecurringPrice = {...parentItem.RecurringPrice};
                item.IsOverridden = false;
            } else if (item.OneOffPrice && item.RecurringPrice && item.IsOverridden === undefined)
                item.IsOverridden = true;
        });

        $scope.oldCollection = JSON.parse(JSON.stringify($scope.planVariantPriceListItems.items));
        $scope.clonedPlanVariantPriceListItems = JSON.parse(JSON.stringify($scope.planVariantPriceListItems.items));
    }

    function GetPlanVariantPriceListItem(item) {
        let priceListItem = null;
        const parentPriceListItem = $scope.fullPlanVariantPriceListItems.find(pl => pl.Id === item.ParentPriceListId) ||
            $scope.productInfo.PriceLists.find(x => x.Id === item.PriceListId).ParentItems?.find(x => x.ProductId === item.ProductId);
        if (parentPriceListItem && parentPriceListItem?.RecurringPrice) {
            priceListItem = parentPriceListItem;
        }
        else if (parentPriceListItem && parentPriceListItem.ParentPriceListId) {
            priceListItem = GetPlanVariantPriceListItem(parentPriceListItem);
        }
        return priceListItem;
    }

    function clearDirty() {
        $scope.planVariantPriceListItems.items.map(function (x) {
            x.dirty = false;
            x.RequestedAction = undefined;
        });
        $scope.unsavedItems = 0;
    }

    function setupDirty() {
        clearDirty();
        $scope.$watch(function () {
            return $scope.planVariantPriceListItems.items;
        }, function (newCollection) {
            let difference = newCollection.filter(function (newItem) {
                let result = true;
                $scope.oldCollection.forEach(function (oldItem) {
                    if (angular.equals(newItem, oldItem)) result = false;
                });
                return result;
            });

            difference.forEach(function (newValue) {
                const oldValue = $scope.oldCollection.find(x => x.Id === newValue.Id);

                // for inherited child items when we map prices items from parent items, we don't want to mark them as dirty
                if (oldValue?.OneOffPrice && !newValue?.OneOffPrice && oldValue?.RecurringPrice && !newValue?.RecurringPrice && oldValue.ParentPriceListId) {
                    newValue.dirty = false;
                }
                else if (oldValue && oldValue.dirty === false && newValue.dirty === false) {
                    $scope.unsavedItems++;
                    newValue.dirty = true;
                }
                if (oldValue?.RecurringPrice?.PricePerUnit !== 0 && newValue?.RecurringPrice && newValue?.RecurringPrice?.PricePerUnit === 0) {
                    newValue.RecurringPrice.PricePerUnit = null;
                }
                if (oldValue?.OneOffPrice?.PricePerUnit !== 0 && newValue?.OneOffPrice && newValue?.OneOffPrice?.PricePerUnit === 0) {
                    newValue.OneOffPrice.PricePerUnit = null;
                }
            });
        }, true)
    }

    $scope.savePrices = function (success) {
        if (!$rootScope.isValid($scope.form)) {
            $scope.form.$$element.context.reportValidity();
            return;
        }

        if ($routeParams.planVariantId) {
            $scope.planVariantPriceListItems.items.forEach(function (item) {
                if (!item.ProductId) {
                    item.ProductId = $scope.planVariant.Id;
                }
                if (item.OneOffPrice && item.OneOffPrice.PricePerUnit == 0) {
                    item.OneOffPrice.PricePerUnit = null;
                }
                if (item.RecurringPrice && item.RecurringPrice.PricePerUnit == 0) {
                    item.RecurringPrice.PricePerUnit = null;
                }
            });

            let data = {
                PriceListItems: $scope.planVariantPriceListItems.items.filter(x => x.RequestedAction !== priceListItemActionEnum.Inherit && x.RecurringPrice && x.OneOffPrice && x.dirty),
                RemovePriceListItems: $scope.planVariantPriceListItems.items.filter(x => x.RequestedAction === priceListItemActionEnum.Inherit && x.dirty)
            };

            if (success)
                PriceListItems.update(data, success);
            else {
                PriceListItems.update(data, function () {
                    SetIsOverridenFlagClearAndCloneItemsAfterUpdate(data);
                });
            }
        }
    };

    function SetIsOverridenFlagClearAndCloneItemsAfterUpdate(data) {
        data.PriceListItems.forEach((item) => {
            item.IsOverridden = !!item.ParentPriceListId;
            updateChildPriceListItems(item);
        });
        data.RemovePriceListItems.forEach((item) => {
            const parentItem = GetPlanVariantPriceListItem(item);
            if (parentItem)
                item.IsOverridden = false;

            updateChildPriceListItems(item);
        });
        clearDirty();
        $scope.oldCollection = JSON.parse(JSON.stringify($scope.planVariantPriceListItems.items));
        $scope.clonedPlanVariantPriceListItems = JSON.parse(JSON.stringify($scope.planVariantPriceListItems.items));
    }

    function updateChildPriceListItems(priceListItem) {
        let items = $scope.fullPlanVariantPriceListItems.filter(x => x.ParentPriceListId == priceListItem.Id && !x.IsOverridden);
        if (items.length) {
            items.forEach(item => {
                item.RecurringPrice = { ...priceListItem.RecurringPrice };
                item.OneOffPrice = { ...priceListItem.OneOffPrice };
                item.IsOverridden = item.IsOverridden ?? false;
                updateChildPriceListItems(item);
            })
        }
    }

    function modify() {
        $scope.savePrices(function () {
            $location.path("/products");
        });
    }

    function create(response) {
        const success = function () {
            $location.path("/products");
        };
        $routeParams.planVariantId = response.Id;
        $scope.planVariant = PlanVariant.get({planVariantId: $routeParams.planVariantId},
            function () {
                $scope.savePrices(success);
            });
    }

    $scope.getAvailableMeteredComponents = function () {
        const existingIds = (($scope.planVariant ? $scope.planVariant.Quota : null) || []).map(function (component) {
            return component.ComponentId;
        });
        return ($scope.components || []).filter(function (component) {
            return component.ComponentType === 'Metered' && !(existingIds.includes(component.Id));
        });
    };

    $scope.newQuota = {};

    $scope.addQuota = function() {
        if (!$scope.planVariant.Quota)
            $scope.planVariant.Quota = [];

        $scope.newQuota.ComponentName =
            $scope.productInfo.ComponentById($scope.newQuota.ComponentId).Name._c; // Use default name only
        $scope.planVariant.Quota.push($scope.newQuota);
        $scope.newQuota = {};
    };

    $scope.deleteQuota = function(index) {
        $scope.planVariant.Quota.remove(index);
    };

    $scope.save = function () {
        if (!$rootScope.isValid($scope.form))
            return;
        $scope.planVariant.RecurringFee = $scope.planVariant.SetupFee = null;
        if ($routeParams.planVariantId)
            $scope.planVariant.$update({planVariantId: $routeParams.planVariantId}, modify);
        else {
            $scope.planVariant.$save({planId: $scope.planVariant.PlanId}, create);
        }
    };

    $scope.$watch("planVariant.BillingPeriod.Unit", function (newValue) {
        if (newValue === "Month" || newValue === "Year" || $scope.planVariant === undefined)
            return;
        $scope.planVariant.BillingDateAlignment = null;
        $scope.planVariant.BillingDay = null;
    });

    const priceListItemActionEnum = Object.freeze({
        "Define": "Define",
        "Override": "Override",
        "Inherit": "Inherit"
    });

    $scope.DefinePrice = function (item) {
        ResetPrice(item);
        item.RequestedAction = priceListItemActionEnum.Define;
    };

    $scope.OverridePrice = function (item) {
        ResetPrice(item);
        item.RequestedAction = priceListItemActionEnum.Override;
    };

    function ResetPrice(item) {
        item.OneOffPrice = {PricePerUnit: "", PriceScale: null, DiscountScale: null};
        item.RecurringPrice = {PricePerUnit: "", PriceScale: null, DiscountScale: null};
        item.IsOverridden = undefined;
    }

    $scope.InheritPrice = function (item) {
        const parentItem = GetPlanVariantPriceListItem(item);
        if(parentItem) {
            item.OneOffPrice = {...parentItem.OneOffPrice};
            item.RecurringPrice = {...parentItem.RecurringPrice};
        }
        item.RequestedAction = priceListItemActionEnum.Inherit;
    }

    $scope.ShowDefinePriceButton = function (item) {
        return item.OneOffPrice == null && item.RecurringPrice == null && !$scope.onePriceListItem && !item.ParentPriceListId;
    }

    $scope.ShowOverridePriceButton = function (item) {
        if (item.IsOverridden || item.RequestedAction)
            return false;

        return !!item.ParentPriceListId;
    }

    $scope.ShowInheritPriceButton = function (item) {
        if (item.RequestedAction)
            return false;

        const parentItem = GetPlanVariantPriceListItem(item);

        // If parent don't have OneOffPrice and RecurringPrice OR parent is in Define mode button will be hidden
        if (!parentItem || (parentItem.RequestedAction === priceListItemActionEnum.Define || (!parentItem.OneOffPrice && !parentItem.RecurringPrice)))
            return false;

        return !!item.IsOverridden;
    }

    $scope.ShowCancelButton = function (item) {
        return item.RequestedAction;
    };

    $scope.IsReadOnlyItem = function (item) {
        // For cases when child uses parent item OR we want to inherit price item will be readonly
        return (item.IsOverridden === false && !!item.ParentPriceListId) ||
            item.RequestedAction === priceListItemActionEnum.Inherit;
    };

    $scope.CancelEditingPlanVariantItem = function (item) {
        const clonedItem = $scope.clonedPlanVariantPriceListItems.find(i => i.PriceListId === item.PriceListId && i.ProductId === item.ProductId);

        // In case of canceling Override action when parent item values is undefined, we need to set OneOffPrice and RecurringPrice to undefined, otherwise we are mapping values from related cloned item
        item.OneOffPrice = (!clonedItem.OneOffPrice && !clonedItem.RecurringPrice) ? undefined : {...clonedItem.OneOffPrice};
        item.RecurringPrice = (!clonedItem.OneOffPrice && !clonedItem.RecurringPrice) ? undefined : {...clonedItem.RecurringPrice};
        item.IsOverridden = clonedItem.IsOverridden;
        item.dirty = false;
        item.RequestedAction = undefined;
        $scope.unsavedItems--;
        $scope.planVariantPriceListItems.items;
    };

    $scope.CancelEditing = function () {
        if (!$routeParams.planVariantId) {
            $scope.planVariantPriceListItems.items.forEach((item) => {
                if (item.dirty === true){
                    $scope.unsavedItems --;
                    item.dirty = false;
                    item.RecurringPrice = undefined;
                    item.OneOffPrice = undefined;
                    item.RequestedAction = undefined;
                }
            })
            return;
        }
        ProductPrices.query({
            productId: $routeParams.planVariantId,
            search: $scope.search
        }).$promise.then(
            function (response) {
                $scope.planVariantPriceListItems.items.forEach((item) => {
                    if (item.dirty === true) {
                        const responseItem = response.filter(r => r.ProductId === item.ProductId && r.PriceListId === item.PriceListId);
                        if (responseItem) {
                            item.OneOffPrice = responseItem[0].OneOffPrice;
                            item.RecurringPrice = responseItem[0].RecurringPrice;
                            item.ParentPriceListId = responseItem[0].ParentPriceListId;
                        } else {
                            item.OneOffPrice = null;
                            item.RecurringPrice = null;
                        }
                        $scope.unsavedItems--;
                        item.dirty = false;
                        item.RequestedAction = undefined;
                    }
                });
                SetIsOverriddenFlagAndCloneItems();
            });
    }

    $scope.cancel = function() {
        $location.path("/products");
    };

    $scope.hidePlural = function (unsavedItems) {
        return String(unsavedItems).slice(-1) === "1";
    };

    gettext("Renew Automatically");
    gettext("End");
    gettext("Change Plan Variant");
};

'use strict';
PlanVariantEditController.$inject = ['$rootScope', '$scope', '$location', '$routeParams', '$q', '$uibModal', 'ProductInfo', 'ProductPrices', 'PriceListItems', 'PlanVariant', 'PlanVariantByPlan', 'gettext'];
